import { Router } from 'express'
import { ensureIsAuthenticated } from '../../middlewares/ensureIsAuthenticatedMiddleware'
import { CreateOriginController } from './createOriginController'
import { FetchOriginsController } from './fetchOriginsController'
import { DeleteOriginController } from './deleteOriginController'
import { ChangeOriginStatusController } from './changeOriginStatusController'

const createOriginController: CreateOriginController = new CreateOriginController()
const fetchOriginsController: FetchOriginsController = new FetchOriginsController()
const deleteOriginController: DeleteOriginController = new DeleteOriginController()
const changeOriginStatusController: ChangeOriginStatusController = new ChangeOriginStatusController()

export const originsRoutes = Router()

originsRoutes.post('/origins', ensureIsAuthenticated, createOriginController.handle.bind(createOriginController))

originsRoutes.get('/origins/list', ensureIsAuthenticated, fetchOriginsController.handle.bind(fetchOriginsController))

originsRoutes.delete('/origins', ensureIsAuthenticated, deleteOriginController.handle.bind(deleteOriginController))

originsRoutes.patch('/origins/change-status/:originId', ensureIsAuthenticated, changeOriginStatusController.handle.bind(changeOriginStatusController))